// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".-mTLq {\n    margin: 0 !important;\n  }\n  .Jk2E- {\n    align-items: center;\n    justify-content: center;\n    flex-direction: row-reverse;\n  }\n  .eHMFN {\n    width: 100%;\n  }\n  .tAZWa {\n    padding: var(--s);\n  }\n  .sl9Jl {\n    max-height: 200px;\n    overflow-y: auto;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"HierarchyAddMenu_divider": "-mTLq",
	"HierarchyAddMenu_hierarchyMenuItem": "Jk2E-",
	"HierarchyAddMenu_addAllButton": "eHMFN",
	"HierarchyAddMenu_hierarchyAddPopover": "tAZWa",
	"HierarchyAddMenu_hierarchyListMenu": "sl9Jl"
};
export default ___CSS_LOADER_EXPORT___;
